import global from '@/utils/Global'

const filters = {
  img(value) {
    return global.fileShowDomain + value;
  },
  f (value, len) {
    try {
      return value.toFixed(len ? len : 2);
    } catch (e) {
      return value;
    }
  },
  json(value) {
    return JSON.stringify(value);
  },
  grade(value){
    switch(value){
      case "04":{return "一年级";}
      case "05":{return "二年级";}
      case "06":{return "三年级";}
      case "07":{return "四年级";}
      case "08":{return "五年级";}
      case "09":{return "六年级";}
      case "10":{return "初一";}
      case "11":{return "初二";}
      case "12":{return "初三";}
      case "13":{return "高一";}
      case "14":{return "高二";}
      case "15":{return "高三";}
      default: return "";
    }
  },
  gradeList(value){
    let arr = value.split('-');
    let arr2=[];
    arr.forEach(element => {
      if(element!=''){ 
        switch(element){
          case "04":{arr2.push("一年级");break;}
          case "05":{arr2.push("二年级");break;}
          case "06":{arr2.push("三年级");break;}
          case "07":{arr2.push("四年级");break;}
          case "08":{arr2.push("五年级");break;}
          case "09":{arr2.push("六年级");break;}
          case "10":{arr2.push("初一");break;}
          case "11":{arr2.push("初二");break;}
          case "12":{arr2.push("初三");break;}
          case "13":{arr2.push("高一");break;}
          case "14":{arr2.push("高二");break;}
          case "15":{arr2.push("高三");break;}
        }
      }
    });
    return arr2.join("，");
  }
}
// 注册到全局
export default {
  install(Vue) {
    Object.keys(filters).forEach(key => {
      Vue.filter(key, filters[key])
    })
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js